export const STATO_TICKET = {
    APERTO: "aperto",
    CHIUSO: "chiuso"
}
